(() => {
  // Lab-grown-blokken står altid i Echo Drop-beskrivelsen, også når krystal er valgt,
  // så kunden kan sammenligne. Indholdet kommer lokaliseret fra pkm-echo-lab-note.liquid.
  function insertNote(description) {
    if (description.querySelector('[data-pkm-echo-igi-note]')) return;

    const template = description.querySelector('template[data-pkm-echo-lab-template]');
    const note = template?.content.querySelector('[data-pkm-echo-igi-note]');
    if (!note) return;

    const stoneLine = [...description.querySelectorAll('li')].find((item) =>
      /^(Sten|Steine|Stenen|Stenar|Steiner|Stones?)\s*:/i.test(
        item.querySelector('strong')?.textContent.trim() || ''
      )
    );
    if (stoneLine) {
      stoneLine.insertAdjacentElement('afterend', note.cloneNode(true));
      return;
    }
    // Ingen stenlinje (fx en omskrevet beskrivelse): sidst i første liste.
    description.querySelector('ul')?.appendChild(note.cloneNode(true));
  }

  function initialize() {
    document.querySelectorAll('[data-pkm-echo-igi]').forEach(insertNote);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
